/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GenerateAssistantResponseRequest = {
    message: string;
    /**
     * Optional model alias forwarded to better-agents. Defaults to Opus when omitted.
     */
    model?: GenerateAssistantResponseRequest.model;
};

export namespace GenerateAssistantResponseRequest {

    /**
     * Optional model alias forwarded to better-agents. Defaults to Opus when omitted.
     */
    export enum model {
        OPUS = 'opus',
        SONNET = 'sonnet',
        HAIKU = 'haiku',
    }


}

